module.exports = __webpack_public_path__ + "static/media/Gallery-6.0629f4f7.jpg";